import { API, encode } from "@lysaab/ui-2";
export var OnfidoRejectReason;
(function (OnfidoRejectReason) {
    OnfidoRejectReason["ONFIDO_DOCUMENT"] = "ONFIDO_DOCUMENT";
    OnfidoRejectReason["ONFIDO_DOCUMENT_TYPE"] = "ONFIDO_DOCUMENT_TYPE";
    OnfidoRejectReason["ONFIDO_PHOTO"] = "ONFIDO_PHOTO";
    OnfidoRejectReason["ONFIDO_FAILED"] = "ONFIDO_FAILED";
})(OnfidoRejectReason || (OnfidoRejectReason = {}));
export var OnboardingStatus;
(function (OnboardingStatus) {
    OnboardingStatus["NOT_FOUND"] = "NOT_FOUND";
    OnboardingStatus["NOT_SIGNED"] = "NOT_SIGNED";
    OnboardingStatus["ONFIDO_PENDING"] = "ONFIDO_PENDING";
    OnboardingStatus["ONFIDO_PENDING_MANUAL_REVIEW"] = "ONFIDO_PENDING_MANUAL_REVIEW";
    OnboardingStatus["ONFIDO_PENDING_USER"] = "ONFIDO_PENDING_USER";
    OnboardingStatus["ONFIDO_FAILED"] = "ONFIDO_FAILED";
    OnboardingStatus["ONFIDO_FAILED_DOCUMENT_TYPE"] = "ONFIDO_FAILED_DOCUMENT_TYPE";
    OnboardingStatus["ONFIDO_FAILED_DOCUMENT"] = "ONFIDO_FAILED_DOCUMENT";
    OnboardingStatus["ONFIDO_FAILED_PHOTO"] = "ONFIDO_FAILED_PHOTO";
    OnboardingStatus["PENDING_MANUAL_REVIEW"] = "PENDING_MANUAL_REVIEW";
    OnboardingStatus["PENDING_CREATION"] = "PENDING_CREATION";
    OnboardingStatus["COMPLETE"] = "COMPLETE";
    OnboardingStatus["REJECTED_MINOR"] = "REJECTED_MINOR";
})(OnboardingStatus || (OnboardingStatus = {}));
export function getStatus(signupId) {
    return API.get(encode `/signup/person/status?signupId=${signupId}`, true);
}
export function getSignupInfo(signupId) {
    return API.get(encode `/signup/person?signupId=${signupId}`, true);
}
